<template>
  <el-form-item
    :key="form.key"
    :label="form.cname+':'"
    :prop="prop"
    :rules="rule">
    <el-input
      v-if="status === 'edit'"
      v-model="form.fieldValue"></el-input>
    <span v-else>{{ form.fieldValue || '&nbsp;' }}</span>
  </el-form-item>
</template>

<script>
export default {
  name: 'FormLink',
  props: {
    item: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    prop: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'edit'
    }
  },
  computed: {
    form: {
      get() {
        return this.item
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    rule() {
      return [
        {
          required: this.form.mandatory,
          message: this.form.cname + '不能为空',
          trigger: 'blur'
        },
        {
          type: 'url',
          message: '请输入正确的' + this.form.cname,
          trigger: 'blur'
        }
      ]
    }
  }
}
</script>
